import engagementBannerStyles from './engagement-banner';

var fixmeTop = 0;

if($('.engagement-banner').offset() != undefined) {
  fixmeTop = $('.engagement-banner').offset().top;
}

var headerHeight = $(".header-static.container-fluid.nav-header").height();
var bannerHeight = $('.engagement-banner').height();

$(window).scroll(function () {
	var currentScroll = $(window).scrollTop();
	if (currentScroll > fixmeTop - headerHeight) {
		$('.engagement-banner').css({
			position: 'fixed',
			top: headerHeight,
			"z-index": '99'
		});
		$('.engagement-banner-layer').remove();
		$('.engagement-banner').after("<div class='engagement-banner-layer' style='height: "+ bannerHeight +"px'></div>");
	} else {
		$('.engagement-banner-layer').remove();
		$('.engagement-banner').css({
			position: 'static'
		});
	}
});

$(".closer__bar-holder").click(function () {
	setTimeout(function () {
    if($('.engagement-banner').offset() != undefined){
      fixmeTop = $('.engagement-banner').offset().top;
    }
	}, 1000);
});
